export const en = {
  clipboard: {
    successCopied: "Copied to clipboard",
  },
  notification: {
    title: "Notification Settings",
    emailNotifications: "Email Notifications",
    marketingEmails: "Marketing Emails"
  },
  safety: {
    title: "KYC Verification",
    subtitle: "Complete verification to access all platform features.",
    bannerTitle: "Verification via Reown",
    bannerText1: "Your account uses Reown authentication.",
    bannerText2: "To upgrade your verification level, go to the \"Verification\" section.",
    standardLevel: "Standard Level",
    standardDesc: "Email and phone number confirmation.",
    enhancedLevel: "Enhanced Level",
    enhancedDesc: "Submission of passport details.",
    professionalLevel: "Professional Level",
    professionalDesc: "Proof of residential address.",
    completed: "Completed",
    inProgress: "In Progress",
    start: "Start"
  },
  referral: {
    title: "Referral Program",
    description: "Invite friends and earn rewards!",
    subtitle: "Your Referral Link",
    yourReferrals: "Your Referrals",
    statsElements: ["Total referrals", "Active", "Total investments", "Your earnings"],
    yourLevel: {
      topTitle: "Your level",
      toNextLevel: "Next level:",
      activeReferralsOr: "active referrals OR",
      toLvl: "to"
    },
    referrer: {
      title: "Have a referral code? Enter it here",
      enterCode: "Enter code",
      check: "Check"
    },
    confirm: "Confirm",
    changeRefCode: "Change referral code",
    newCode: "new code",
    enterNewCode: "Enter your new code",
    minMaxChars: "Minimum 6 characters, maximum 8"
  },
  referralNew: {
    code: {
      title: 'Got a referral code?',
      description: 'Enter it below to connect with\nyour inviter.',
      input: 'Referral code',
      button: 'Verify',
      title_CodeVerified: 'Code verified',
      description_CodeVerified: 'You can now invite others and earn rewards.',
      youInviter: 'your inviter'
    },
    details: {
      title: 'Your referral details',
      description: 'Invite friends to Zenex and earn bonuses.',
      sendThis: 'Send this link to your friend',
      orShare: 'Or share your manual code',
      members: 'members',
      paidOut: 'paid out in 2025',
      alreadyEarning: 'already earning with us'
    },
    program: {
      button: 'Learn more',
      cards: {
        title: 'Monthly tiers',
        subtitle: 'Partner Program',
        description: 'Earn on your referrals’ card turnover',
        how: 'How it works',
        elements: [
          'Total top-up volume\nof all referrals per\ncalendar month',
          'Status recalculated on\nthe 1st of each\nmonth',
          'Commission paid\naccording to your\ncurrent tier'
        ]
      },
      invest: {
        title: "Cumulative system",
        subtitle: "Referral Program",
        description: "Earn from your friends’ investments",
        how: "How to earn",
        elements: [
          "Invite a friend to join\nZenex Invest",
          "They start investing in\nZenex Pools",
          "You receive rewards\nfrom their earnings"
        ]
      }
    }
  },
  innerReferral: {
    title: "Referral Program \n Zenex Invest",
    statistic: {
      pattern: " this month",
      status: {
        title: "Current Status",
        subtitle: "Your bonuses: ",
        description: "{depositBonus} from deposit and {incomeBonus} from profit",
        labelLeft: "Until {level}",
        labelCenter: "{count, plural, one {# referral} other {# referrals}} or",
        labelRight: ""
      },
      referrals: {
        title: "Active Referrals",
        description: "+{count} new",
      },
      deposit: {
        title: "Total Deposit Amount",
        description: "+{count}$"
      },
      income: {
        title: "My Income",
        description: "~{count}$",
        pattern: "/per month",
      },
    },
    link: {
      title: "Increase your rank and earn more",
      sendThis: "Send this link to a friend",
      orShare: "Or share the code for manual entry",
    },
    tabs: {
      levels: "Level System",
      history: "Payout History",
      referrals: "Referral List",
    },
    faq: {
      kicker: "FAQ",
      title: "How the referral system works",
      questions: [
        "Where are my referral rewards credited, and how can I withdraw them?",
        "Is the referral link different for each product, or is there a single link?",
        "I referred a friend, and they invested in the RevShare pool. When will I receive my reward?",
        "How can I increase my level in the referral program?",
      ],
      answers: [
        "Your referral rewards are credited directly to the wallet connected to your Zenex Hub account and you can withdraw them to any external crypto wallet.",
        "There is one unified referral link for all Zenex products. By sharing a single link, you receive rewards from every product your referral uses.",
        "Referral rewards are credited starting from the following month. You earn both a share of their deposit (one-time reward) and a share of their profits (recurring monthly rewards).",
        "Your level increases once the total investment volume of your referrals reaches the requirement for the next tier. The new level is applied at the start of the next calendar month.",
      ],
    },
    levels: {
      title: "Level and Reward System",
      description: "Your level is determined by the best indicator: the number of active referrals or the total amount of their investments",
      status: {
        received: "Received",
        current: "Current Level",
        blocked: "Locked",
        more: "Another {count, plural, one {# referral} other {# referrals}}",
      },
      level: {
        associate: "Associate",
        partner: "Partner",
        executive: "Executive",
        elite: "Elite",
        ambassador: "Ambassador",
      },
      rows: {
        referrals: "Referrals",
        total: "Total Deposit Amount",
        incomeDeposit: "Income from Deposit",
        incomeStable: "Income from Stable Pool Deposit",
        incomeGrowth: "Income from Growth Pool Profit",
      },
    },
    filters: {
      label: "Sort by",
      dateAscending: "Date: ascending",
      dateDescending: "Date: descending",
      incomeAscending: "Income: ascending",
      incomeDescending: "Income: descending",
    },
    pagination: "Page {current} of {total}",
    incomeHistory: {
      title: "Income and Payout History",
      column: {
        date: "Date",
        user: "Referral",
        pool: "Pool",
        incomePercent: "Profit",
        income: "Amount",
      },
    },
    referrals: {
      title: "My Referrals",
      column: {
        user: "Referral",
        pool: "Pool",
        deposit: "Invested",
        profit: "Referral Profit",
        earning: "My Income",
      },
    },
  },
  quest: {
    title: "Tasks and achievements",
    subtitle: "Complete tasks to earn bonuses and rewards!",
    subscribe: "Subscribe to our Instagram!",
    follow: "Follow us on X!",
    join: "Join our Telegram!",
    done: "Done",
    complete: "Complete"
  },
  account: {
    title: "Account",
    fields: {
      name: "Name",
      nickname: "Nickname",
      email: "Email",
      bio: "Bio"
    },
    verify: "Verify",
    confirmChanges: "Confirm Changes",
    updateSuccess: "Changes saved successfully",
    updateError: "Failed to save changes",
    linksTitle: "Link your accounts for additional features",
    connectX: "Connect X",
    connectTelegram: "Connect Telegram",
    connectInstagram: "Connect Instagram",
    logout: "Log Out",
    emailDialog: {
      title: "Verify Your Email",
      description1: "We’ve sent a 6-digit code to {email}",
      description2: "Enter it below to complete your registration and access all Zenex Hub features.",
      confirmBtn: "Confirm email",
      cantFind: "Can’t find the email? Check your Spam folder",
      resend: "or request a new one",
      sentPrefix: "We’ve sent a 6-digit code to"
    },
    cancel: "Cancel",
    saveChanges: "Save Changes",
    selectNewAvatar: "Select new Avatar",
    unsavedChanges: {
      title: "Unsaved Changes",
      subtitle: "You have unsaved changes. Discard them and leave?"
    }
  },
  sell: {
    to: "Withdraw to",
    select: "Select token",
    button: "Withdraw",
    loading: "Withdrawing…"
  },
  errors: {
    insufficientFunds: "Insufficient funds",
    maxLimit: "Maximum limit is {value}$",
    serviceUnavailable: "Service unavailable, please try again later",
  },
  card: {
    title: {
      white: "— The Next Era of Card Payments Starts Here!",
      green: "by Zenex",
      yellow: "NS.Cards"
    },
    description:
      "Zero transaction fees, MCC restrictions, spending limits up to $100,000 — all this and more with the Zenex card.",
    button: "Get your card",
    columns: {
      left: {
        title: {
          white: "NS.CARDS for\n",
          green: "Mediabuyers"
        },
        items: [
          "Top-up with crypto or fiat from 2.5%",
          "No KYC",
          "0% Transaction fees on ADS-related MCCs"
        ],
        cta: "Get the card"
      },
      right: {
        title: {
          white: "NS.CARDS",
          yellow: "No-Limits Wild card"
        },
        items: [
          "Top up with crypto or fiat from 2.5%",
          "No MCC Limits",
          "Apple Pay/Google Pay + Plastic options",
          "$100k/month for your transactions"
        ],
        cta: "Get the card"
      }
    }
  },
  investHome: {
    title: "RevShare Pools",
    description:
      "The first iGaming RWA  — Fund casino traffic and earn a % of the platform's GGR by joining ZNX RevShare pools for conservative or high-yield gains.",
    button: "Zenex Invest"
  },
  invest: {
    title: "Traffic Pools",
    description:
      "Participation in NGR from White Rabbit Casino traffic (Kazakhstan) - whiterabbit.casino \n" +
      "We buy high-quality traffic, convert it into deposits, and share the profit.",
    button: "Follow Updates",
    dashboardTitle: "Investment Dashboard",
    secondPageDescription1: "Earn GGR from Casino Platforms.",
    secondPageDescription2: "We buy high-quality traffic, convert it into deposits, and share the profit.",
    dashboardDescription: "Manage your investments and track performance across all pools.",
    investFirstRowElements: [
      "years of experience", "Reg2Dep", "monthly ROI", "from GGR= NGR"
    ],
    poolsTitle: "Available pools",
    pools: ["members", "types of pools", "months", "ZNX\n" + "total limit"],
    poolsOffers: {
      titlesStable: ["100% capital return guarantee", "34-42,5% from GGR", "Payouts in USDC"],
      titlesGrowth: ["Maximum upside from ZNX", "8,5-12,75% from GGR", "Payouts in USDC"],
      whyHint: {
        safeTitle: "Why Higher % of GGR?",
        safeText: "We acquire your ZNX at current USD value. Higher % because\nwe buy your tokens and share maximum profits. Guaranteed\nreturn on your investment in USD equivalent keeps your funds\nsafe.",
        growthTitle: "Why Lower % of GGR?",
        growthText: "For 12 months, we handle the management of your ZNX tokens,\nensuring that you receive your entire investment back at the end\nof the term. Lower % because you keep ownership and token\ngrowth potential"
      },
      amountStaked: "Amount Staked"
    },
    poolsOffersRow: {
      payoutsStable: ["34% from GGR", "38,25% from GGR", "42,5% from GGR"],
      payoutsGrowth: ["8,5% from GGR", "10.625% from GGR", "12,75% from GGR"]
    },
    poolButton: "Enter the pool",
    nrgComeFrom: {
      title: "Where does NGR for payouts come from?",
      nrgElements: {
        titles: ["GGR from players", "Minus 15%", "= NGR", "To pool participants"],
        subTitles: ["Gross Gaming Revenue", "Casino administrative\n" + "expenses", "Net Gaming Revenue", "According to tier\n" + "and pool type"]
      },
      description: "Example: GGR $100k → NGR $85k → Participants receive between $8.5k and $42.5k, depending on pool and tier."
    },
    howItWorks: {
      title: "How It Works?",
      elements: {
        titles: ["Pooling ZNX Tokens", "Traffic Acquisition", "Profit Generation", "Monthly Payouts", "Return of Initial Investment"],
        descriptions: [
          "Pool participants deposit ZNX tokens up\n" + "to a limit of 230k tokens/month",
          "We purchase high-quality traffic via CPA-model\n" + "for White Rabbit Casino",
          "The casino earns GGR\n= players’ “losses” – players’ “wins”",
          "Pool participants receive a % of GGR\nin USDC based on tier and pool type every month",
          "The tokens you placed in the pool\nwill be fully returned after 12 months"
        ]
      }
    },
    faq: {
      title: "Frequently Asked Questions",
      questions: [
        "What are Zenex RevShare Pools?",
        "How are payouts made?",
        "How is my monthly payout calculated?",
        "Can I exit a pool early?",
        "What happens if the pool doesn't reach the target amount?",
        "When will my ZNX be returned?",
      ],
      answers: [
        "Zenex RevShare Pools is an RWA tokenization of real casino business. You acquire ZNX tokens, place them in traffic acquisition pools for <span>whiterabbit.casino</span>, and receive a fixed percentage of Gross Gaming Revenue (GGR) every month for 12 months.",
        "Payouts are made monthly in USDC on the 15th of each month for 12 months. Funds arrive to your ZNX Hub balance, you can withdraw them immediately or reinvest.",
        "Your payout depends on two things: your share of the pool and the casino’s monthly GGR performance.",
        "No, early exit is impossible. Funds are locked in smart contract for 12 months. This allows us to plan marketing campaigns and guarantee stable returns.",
        "The Pool will be launched anyway. Profit distribution proportions will be determined after the monthly traffic purchases will be made.",
        "100% of ZNX tokens that you placed in the pool will be returned automatically after 12 months.",
      ]
    },
    betshops: {
      title: "Betshops"
    },
    questions: {
      title: "Still Have Questions?",
      subtitle: "Contact our team now to find the best pool for your goals!",
      button: "Get in touch"
    },
    moreInfo: {
      title: "More Information About Zenex RevShare Pools",
      telegram: "Our Telegram",
      instagram: "Our Instagram",
      linkedin: "Our Linkedin"
    },
    payoutVariations: {
      title: "How payouts can vary",
      inputLabel: "Enter the investment amount",
      weakLabel: "Weak Scenario",
      strongLabel: "Strong Scenario",
      months: [
        "Today",
        "Jan 2025",
        "Apr 2025",
        "Jul 2025",
        "Oct 2025",
        "Jan 2026",
        "Apr 2026",
        "Jul 2026",
        "Oct 2026",
        "Dec 2026"
      ],
      weakScenarioLabel: "Weak Scenario total return (No price growth)",
      strongScenarioLabel: "Strong Scenario total return (150% price growth)",
      disclaimer: "Calculations are based on historical performance and are not forecasts."
    },
    header: {
      smallTitle: "Zenex RevShare Pools",
      mainHeading: "Tap into casino revenue without the operational costs and risks",
      description: "We buy high-quality traffic for casinos, convert it into deposits, and share the profits",
      ctaStartEarning: "Start Earning",
      ctaViewStatistics: "View Statistics",
      stats: {
        item1: {
          value: "60 months",
          description: {
            prefix: "Proven profitability of",
            link: "White Rabbit Casino"
          }
        },
        item2: {
          value: "40%+",
          description: "Industry-leading reg-to-dep conversion"
        },
        item3: {
          value: "Transparent",
          description: "Performance reporting and monthly data"
        },
        item4: {
          value: "Two income streams",
          description: "Monthly USDC payouts, plus your full ZNX back with upside potential"
        }
      }
    },
    enterToPoolDialog: {
      title: "Enter the pool",
      availableBalance: "Available balance",
      stakedInPool: "Staked in this pool",
      buttonTopUp: "Top up balance",
      buttonEnterPool: "Enter the pool",
      choosePlan: "Choose your plan",
      inputLabel: "Enter ZNX amount",
      inputMessages: {
        exceedsBalance: "Exceeds Balance",
        increase: {
          toIncrease: "To increase your",
          addAdditional: "add an additional",
          stable: {
            toBasic: "GGR to 34%",
            toAdvanced: "GGR to 38.25%",
            toPremium: "GGR to 42.5%"
          },
          growth: {
            toBasic: "GGR to 8.5%",
            toAdvanced: "GGR to 10.625%",
            toPremium: "GGR to 12.75%"
          }
        }
      }
    },
    myActivePools: {
      title: "My Active Pools",
      myActivePoolElements: ["Staked", "Current\n" + "Plan", "GGR"],
      myActivePoolElementsV2: ["Pool size", "Staked", "Current Plan", "GGR", "Total earned"],
      growUp: "Upgrade your plan to boost earnings!",
      missing: "Missing",
      buttonStats: "View Stats",
      buttonAddZNX: "Add ZNX",
      buttonClaim: "Claim",
      months: {
        january: "January",
        february: "February",
        march: "March",
        april: "April",
        may: "May",
        june: "June",
        july: "July",
        august: "August",
        september: "September",
        october: "October",
        november: "November",
        december: "December"
      },
      status: {
        active: "Active until {date}",
        prefunding: "Pre-funding",
        closed: "Closed",
      },
      upgrade: {
        label: "Upgrade your plan to",
        boost: "Boost earnings to {percent}% from GGR({ggr})",
        missing: "Missing: ",
      },
    },
    stats: {
      title: "White Rabbit Analytics Dashboard",
      description: "Operational Analytics",
      claimButton: "Claim",
      chartPerios: ["1d", "1w", "1m"],
      chartLine: "Dynamics of GGR",
      barLine: "Dynamics Active Players",
      addZnx: "Add ZNX",
      spent: "Spent",
      ftdLabel: "FTD\n(First-Time Depositors)",
      cpaLabel: "CPA\n(Cost per FTD)",
      averageDeposit: "Average Deposit",
      ggrThisMonth: "GGR this month",
      totalGgr: "Total GGR",
      day: "Day {day}",
      activity: {
        title: "Pool Activity Status",
        status: {
          active: "Active until {date}",
          prefunding: "Pre-Funding",
          closed: "Closed",
          traffic: "Traffic acquisition"
        },
      },
      prefunding: {
        goal: "Fundraising Goal",
        raised: "Raised",
        investors: "Investors",
        launch: "Launch In"
      },
      stake: {
        label: "My stake",
        elements: ["Staked", "Current Plan", "GGR", "Next payment date", "Total earned"],
      },
      upgrade: {
        label: "Upgrade your plan to",
        boost: "Boost earnings to {percent}% from GGR({ggr})",
        missing: "Missing: ",
      },
      placeholderPool: {
        title: "Statistics will appear after pool launch",
        description: "Invest now to get first access to performance data!",
        action: "Join Pool",
      },
      myPayouts: {
        title: "My Payouts",
        action: "Claim",
        pool: "{pool} {month} payout",
        stable: "Stable Pool",
        growth: "Growth Pool",
        eta: {
          days: "{count, plural, one {# day} few {# days} many {# days} other {# days}}",
          hours: "{count, plural, one {# hour} few {# hours} many {# hours} other {# hours}}",
        },
      },
      months: {
        january: "January",
        february: "February",
        march: "March",
        april: "April",
        may: "May",
        june: "June",
        july: "July",
        august: "August",
        september: "September",
        october: "October",
        november: "November",
        december: "December"
      },
      yourPayouts: "Your"
    },
    transparency: {
      title: "Transparency",
      lastUpdated: "Last updated:",
      dataSource: "Data source:",
      crossGamingRevenue: "Gross Gaming Revenue",
      adminFee: "Admin Fee (15%)",
      netGamingRevenue: "Net Gaming Revenue",
      totalDeposits: "Total Deposits",
      playersCount: "Players Count"
    },
    overview: {
      title: "Personal Investment Overview",
      totalInvested: "Total invested",
      totalEarned: "Total earned",
      nextPayout: "Next payout",
      poolShare: "Your pool share:",
      roi: "ROI:",
      paymentDate: "Payment date:",
      poolMetrics: "Pool Metrics",
      poolSize: "Pool Size",
      investors: "Investors",
      staked: "Staked",
      players: "Players"
    },
    totalStaked: {
      title: "Total Staked in Pools",
      button: "Invest in Pools",
      stable: "stable pool",
      growth: "growth pool",
      totalFormat: "{total}/{max} ZNX"
    },
    whiteRabbitPromo: {
      title: "White Rabbit Pool Stats",
      subtitle: "See the numbers, calculate your earnings, join now",
      button: "Open Statistics"
    },
    poolMetrics: {
      title: "Pool Metrics",
      metricsElements: ["Pool Size", "Investors", "Staked", "Players"]
    },
    growthDetails: {
      title: "Zenex Growth Pool",
      progress: {
        label: "Pool Progress"
      },
      metrics: {
        ggrShareLabel: "Share of casino GGR",
        lockPeriodLabel: "Lock period",
        lockPeriodValue: "12 months",
        payoutsUSDCLabel: "Payouts in USDC",
        payoutsFrequencyValueMonthly: "Monthly",
        returnedAfterLabel: "Returned after 12 months",
        returnedAfterValue: "100% ZNX"
      },
      tooltips: {
        tierShare: "Your share of casino depends on Tier",
        payoutsDepend: "Payouts depend on casino’s monthly GGR",
        noEarlyWithdrawal: "No early withdrawal",
        znxGrowth: "If ZNX grows — your final return grows too"
      },
      tier: {
        depositLabel: "Deposit:",
        note: "Tier determined automatically by deposit amount"
      },
      button: {
        closed: "Fundraising is closed"
      }
    },
    joinPool: "Join Pool",
    poolsPromoTitle: "Statistics will appear after pool launch",
    poolsPromoSubtitle: "Invest now to get first access to performance data!"
  },
  buy: {
    currency: "Currency",
    network: "Network",
    sum: "Amount",
    min: "Minimum",
    max: "Maximum",
    loading: "Loading…",
    buy: "Buy",
    approve: "Transfer {amount} {currency} to address:"
  },
  claim: {
    have: "You have",
    available: "tokens available",
    description:
      "Click the \"Claim\" button to add them to your account balance.",
    button: "Claim",
    check: "Check",
    total: "Your total score",
    tooltip: "Optional field",
    notice: {
      white: "Enter the bonus code to get",
      green: "x2 ZNX tokens."
    },
    errors: {
      invalidCode: "Invalid code",
      codeExpired: "The code is expired.",
      codeRequired: "The code is required."
    },
    optional: "Optional field"
  },
  page: {
    title: {
      green: "Welcome to",
      yellow: "Zenex Hub!"
    },
    descriptions1:
      "Thank you for believing in us and wanting to grow with us!",
    descriptions2:
      "We’re in the final testing phase and will soon unveil our full functionality.",
    descriptions3: "Play now to claim your",
    descriptions4: "free tokens",
    descriptions5: "—don’t miss out!",
    buttons: {
      play: "Play Treasure Hunt",
      get: "Get ZNX"
    },
    notice: "This offer is available for a short time only.",
    back: "Back",
    tabs: {
      account: "Account",
      safety: "Safety",
      notifications: "Notifications",
      referrals: "Referrals",
      quests: "Quests"
    }
  },
  balance: {
    title: "Your NFT collections"
  },
  header: {
    title: {
      profile: "Profile Settings",
      reshare: "Investment"
    },
    welcome: "Welcome {username}!",
    welcome_empty: "Welcome!",
    button: {
      logout: "Logout"
    },
    labels: {
      address: "Address:",
      caipAddress: "CAIP Address:",
      status: "Status:"
    },
    dropdown: {
      supportChat: "Support chat",
      documents: "Documents",
      legalDocuments: "Legal documents",
      termsOfUse: "Terms of Use",
      privacyPolicy: "Privacy Policy",
      cookiesPolicy: "Cookies Policy",
      buyZNXwithCrypto: "Buy ZNX with Crypto",
      buyZNXonDEX: "Buy ZNX on DEX",
      buyZNXwithCard: "Buy ZNX with Card"
    }
  },
  login: {
    title: {
      green: "Welcome to",
      white: "Zenex Hub!"
    },
    button: "Connect"
  },
  plans: {
    title: "Zenex Investment Access Programs",
    welcome: "Welcome {username}!",
    welcome_empty: "Welcome!",
    cards: {
      silver: {
        title: "Silver Tier",
        subtitle: "Early Investor",
        items: [
          "1,000 spots",
          "ZNX Play: Staking ×1.5 (6 mo.)",
          "ZNX Arena: 5 standard cards + 1 gold",
          "ZNX Invest: Exclusive pool access",
          "Bonus: 850 ZNX"
        ]
      },
      gold: {
        title: "Gold Tier",
        subtitle: "Strategic Partner",
        items: [
          "200 spots",
          "ZNX Play: Staking ×2 (12 mo.)",
          "ZNX Arena: 8 standard cards + 2 gold",
          "ZNX Invest: +10% pool yield",
          "Bonus: 4,200 ZNX"
        ]
      },
      platinum: {
        title: "Platinum Tier",
        subtitle: "VIP Investor",
        items: [
          "50 spots",
          "ZNX Play: Staking ×3 (12 mo.)",
          "ZNX Arena: 10 standard cards + 3 gold",
          "ZNX Invest: +20% pool yield",
          "Private insider chat",
          "Bonus: 12,500 ZNX"
        ]
      },
      diamond: {
        title: "Diamond Tier",
        subtitle: "Founding Partner",
        items: [
          "20 spots",
          "ZNX Play: Staking ×4 (12 mo.)",
          "ZNX Arena: 10 standard cards + 5 gold",
          "ZNX Invest: +30% yield + guaranteed allocations",
          "Private chat + platform influence",
          "Hall of Fame mention",
          "Bonus: 12,500 ZNX"
        ]
      }
    },
    button: "Buy",
    available: "Available Positions",
    benefits: "Benefits"
  },
  opportunities: {
    cards: {
      play: {
        title: "ZNX Play",
        description: "Hold ZNX, earn rewards— zero effort required."
      },
      invest: {
        title: "ZNX Invest",
        description:
          "Earn with the first iGaming RWA with just 50 ZNX"
      },
      cases: {
        title: "Cases & Chests",
        description: "Open cases for random rewards, boosters, or perks."
      },
      arena: {
        title: "ZNX Arena",
        description:
          "Profit from promoters competing for clients in a business reality show."
      }
    },
    button: "Coming soon",
    buttonOpen: "Open"
  },
  meta: {
    title: "English"
  },

  cards: {
    transactions: { 
      title: 'Last transactions',
      column: {
        card: "Card",
        date: "Date",
        details: "Details",
        status: "Status",
        amount: "Amount",
        fee: "Fee"
      },
      status: {
        RESERVED: "Reserved",
        UNRESERVED: "Unreserved",
        TRANSFERRED: "Transferred",
        REFUNDED: "Refunded",
        REFUNDED_PARTIAL: "Refunded Partial",
        FAILED: "Failed",
        LOADED: "Loaded",
        UNLOADED: "Unloaded",
        COMPLETED: "Completed"
      }
    },
    myCards: {
      title: "My Cards",
      goToSite: "Go to NS.Cards",
      balance: 'Balance',
      buyNewCards: "Buy new card",
      cardRedirect: "You'll be redirected to an external service to finish your purchase",
      topUpZnx: "Top up with ZNX",
      confirmTopUp: "Confirm top up",
      topUpAmount: 'Top up Amount',
      viewAllCards: 'View all cards',
      hideCards: 'Hide cards',
      loading: 'Loading',
      loadingAddress: 'Loading deposit address...',
    }
  },
  wallet: {
    title: {
      main: "Wallet",
      mainNew: "Non-custodial wallet",
      cards: "Zenex Cards",
      balance: "Total Assets",
      transaction: "Transaction History",
      calendar: "Payment Calendar",
      payments: "Upcoming Payments"
    },
    availableBalance: "Available balance",
    chooseAssets: "Choose an asset",
    walletNetworkDeposit: "Deposit network",
    walletNetworkWithdraw: "Withdraw network",
    address: "Address",
    destinationAddress: "Destination address",
    enterAddress: "Enter address",
    pasteWalletAddress: "Paste wallet address",
    enterAmount: "Enter amount",
    withdrawAmount: "Withdraw amount",
    minimumWithdrawAmount: "Minimum withdraw amount: {value}",
    transactionDetails: "Transaction details",
    transactionFee: "Transaction fee",
    insufficientFundsForFee: "Insufficient funds to cover the transaction fee.",
    missing: "Missing: {value}",
    addSol: "Add SOL",
    paste: "Paste",
    max: "Max",
    doubleCheckWithdraw: "Please double check the withdraw address!",
    doubleCheckDeposit: "Please double check the deposit address!",
    sendingFundsToWrong: "Sending funds to the wrong address may result in the irretrievable loss" + "\n" + "of your cryptocurrency.",
    theProcedureUpTo48Hours: "The procedure can take up to 1-2 minutes!",
    theProcedureUpTo30min: "The procedure can take up to 30 minutes",
    exRate: "Exchange Rate",
    swap: "Confirm",
    sell: "Sell",
    receive: "Receive",
    send: "Send",
    mainTitle: "Exchange",
    amount: "Amount",
    toSwap: "Swap",
    searchTokens: "Search any token",
    selectCurrency: "Select a currency",
    selectCurrencyOrNetwork: "Select a currency or network",
    selectToken: "Select token",
    selectNetwork: "Select network",
    continueInWallet: "Continue in wallet",
    swapReview: "Please review transaction details" + "\n" + "before confirmation!",
    depositAddress: "Deposit address",
    walletDepositLoading: "Please wait, your deposit address is being generated...",
    walletSwapDepositLoading: "Please wait while your swap operation is initiating ",
    swapPage: {
      youSend: "You Send",
      youReceive: "You Receive",
      swapMinDeposit: "Min Deposit",
      fee: "Fee",
      feeWithdraw: "Fee Withdrawal",
      finish: "Finish",
      swapSuccess: "Swap completed successfully",
      swapError: "Swap failed. Please try again."
    },
    balanceButtons: {
      deposit: "Deposit",
      withdraw: "Withdraw",
      exchange: "Exchange",
      buyZNX: "Buy ZNX"
    },
    transactionHistory: {
      type: "Type",
      total: "Total",
      info: "Info",
      date: "Date",
      status: "Status"
    }
  },
  paymentProcess: {
    awaitingPayment: "Awaiting Payment",
    confirmed: "Confirmed",
    swapped: "Swapped",
    swapping: "Swapping",
    sending: "Sending ZNX",
    sendingToken: "Sending {token}",
    usualTime: "This usually takes 5-30 minutes."
  },
  transactionStatus: {
    complete: "Transaction Complete!",
    failed: "Transaction Failed",
    withdrawFailed: "Withdrawal failed",
    successSend: "{token} has been successfully sent to your wallet.",
    errorOccurred: "An error occurred while processing the transaction.",
    viewOnExplorer: "View on Block Explorer",
    contactSupport: "Contact Support",
    backToWallet: "Back to wallet",
    withdrawComplete: "Withdrawal complete!",
    withdrawAmountLabel: "Withdraw amount",
    destinationAddressLabel: "Destination address",
    estimatedProcessingTimeLabel: "Estimated processing time",
    transactionFeeLabel: "Transaction fee",
    continueInWallet: "Continue in wallet",
    checkOnSolscan: "Check on Solscan",
    withdrawEtaValue: "{value} minutes",
    withdrawEtaDefault: "1-2 minutes",
    swapComplete: "Swap complete!",
    swapFailed: "Swap failed",
    youSendLabel: "You send",
    exchangeRateLabel: "Exchange Rate",
    youGetLabel: "You get"
  },
  play: {
    banner: {
      title: "Staking & Lottery",
      description: "Stake your $ZNX tokens to earn rewards. The longer you stake, the higher your chances to win!"
    },
    statsSmall: {
      previousJackpot: "Previous Jackpot",
      upcomingPayment: "Upcoming Payment",
      activeParticipants: "Active Participants"
    },
    ctaStake: "Stake and win",
    chipActive: "Active",
    stats: {
      totalValueStaked: "Total Value Staked",
      activeStakers: "Active Stakers",
      currentPrizePool: "Current Prize Pool"
    },
    nextDraws: {
      title: "Next Draws",
      description: "Countdown to the upcoming prize lottery. Don’t miss your chance!"
    },
    jackpots: {
      weekly: "WEEKLY JACKPOT",
      monthly: "MONTHLY JACKPOT",
      annual: "ANNUAL JACKPOT"
    },
    time: {
      days: "Days",
      hours: "Hours",
      minutes: "Minutes"
    },
    prizeSub: "in the prize pool",
    stakeDialog: {
      header: "Start Staking",
      description: "Choose amount and duration for maximum profit potential",
      labelAmount: "Amount to Stake (ZNX)",
      placeholderAmount: "Enter the amount",
      max: "MAX",
      infoMessage: "Increase stake to 500 ZNX to double your potential profit!",
      plan: {
        multiplier: "Multiplier",
        labelApy: "Fixed APY"
      },
      stats: {
        weeklyDistribution: "Weekly Distribution",
        monthlyDistribution: "Monthly Distribution",
        totalPotentialProfit: "Total Potential Profit"
      },
      createStake: "Create Stake"
    },
    summaryRow: {
      stakeAmount: "Stake Amount",
      duration: "Duration",
      fixedApy: "Fixed APY",
      guaranteedProfit: "Guaranteed Profit",
      additionalProfitChance: "Additional Profit Chance"
    }
  },
  connectDialog: {
    text: "Connect your wallet to see all available products!",
    button: "Connect Wallet"
  },
  profileCard: {
    hiUser: "Hi, User",
    copyFullAddress: "Copy full address",
    profileSettings: "Profile Settings"
  },
  welcomeDashboard: {
    subTitle: "Engage. Earn. Empower.",
    description: "The first iGaming-Fintech ecosystem with Casino RWA and Revolutionary solutions!",
    button: "Connect Wallet",
    revsharePools: {
      titleAccent: "Revshare",
      titleRest: "pools",
      description1: "The first iGaming RWA — Fund CPA casino traffic and earn a % of the platform’s revenue (GGR)",
      description2: "by joining ZNX RevShare pools for conservative or high-yield gains.",
      cta: "Start Earning"
    },
    dashboardElements: {
      invest: {
        text: "Earn every month from the industry leading\nCasino RWA products",
        button: "Earn ZNX & USDC"
      },
      play: {
        text: "Hold ZNX, earn passive income,\nand multiply it in our mini-games.",
        button: ""
      },
      arena: {
        text: "Profit from promoters competing for clients in the first casino business reality show.",
        button: ""
      }
    },
    dashboardReferral: {
      boost: "Boost your earnings with",
      programName: "Referral Program"
    },
    dashboardConnect: {
      subTitle: 'Engage. Earn. Empower.',
      text: 'The first iGaming-Fintech ecosystem\n with Casino RWA and Revolutionary solutions!'
    },
    dashboardPartners: {
      title1: 'Global Network.',
      title2: 'Shared Vision.',
      subTitle: 'Integrated with top iGaming and fintech partners, we harness blockchain and smart contracts technologies\n to develop next-generation solutions.'
    },
    dashboardPhotos: {
      title: "Moments",
      subtitle: "People. Energy. Innovation.",
      followUs: "Follow us for more moments",
      texts: {
        We_brought: "We brought the Web3 spirit to MAC Yerevan",
        Innovation_networking: "Innovation, networking, and bold ideas — that’s CPA Life Fest with Zenex",
        Zenex_at: "Zenex at BroConf — pure energy",
        Connecting_minds: "Connecting minds at TOKEN2049",
        Game_on: "Game on at SBC Summit",
        From_insights: "From insights to action — at CPA Life Fest",
        TOKEN2049_vibes: "TOKEN2049 vibes: real talks, growth, energy",
        Behind_every: "Behind every event, there’s a story — of bold ideas,partnerships, and unforgettable experiences that move the Zenex community forward.",
        Bright_ideas: "Bright ideas, SiGMA"
      }
    },
  },
};